<div class="mt-4 mb-4 d-flex">
    <button mat-raised-button color="primary" class="primary-btn  ms-auto no-sh-btn s-lbtn" type="submit" (click)="onAddBank()">
    <i class="fas fa-plus"></i> {{"COMMON.ADD" |translate}} {{"COMMON.BANK"|translate}}</button>
</div>
<div class="w-100" style="overflow-x: auto;" *ngIf="dataSource.data.length!=0">
    <table class="mt-2 mt-sm-3 mt-md-4" mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <ng-container matColumnDef="acc_no">
        <th mat-header-cell *matHeaderCellDef>{{"EMPLOYEE.BANK.ACCOUNTDETAIL" | translate}}</th>
        <td mat-cell *matCellDef="let element" class="td-1">
            <div> {{element.ac_hn}}</div>
            <div class="sub-head"> {{element.ac_n}}</div>
        </td>
      </ng-container>
      <ng-container matColumnDef="bank_name">
        <th mat-header-cell *matHeaderCellDef>{{"EMPLOYEE.BANK.BANKDETAIL" | translate}}</th>
        <td mat-cell *matCellDef="let element" class="td-1">
            <div class="add-head"> {{element.b_n}}</div>
            <div class="sub-head add-head hide-lines-2" > {{element.b_add}}</div>
        </td>
      </ng-container>
      <ng-container matColumnDef="iban">
        <th mat-header-cell *matHeaderCellDef>{{"EMPLOYEE.BANK.IBAM" | translate}}</th>
        <td mat-cell *matCellDef="let element" class="td-1">
            {{element.ib_n}}
        </td>
      </ng-container>
      <ng-container matColumnDef="sort_code">
        <th mat-header-cell *matHeaderCellDef>{{"EMPLOYEE.BANK.SORTCODE" | translate}}</th>
        <td mat-cell *matCellDef="let element" class="td-1">
            {{element.s_c}}
        </td>
      </ng-container>
      <ng-container matColumnDef="pps_number">
        <th mat-header-cell *matHeaderCellDef>{{"EMPLOYEE.BANK.PPSNUMBER" | translate}}</th>
        <td mat-cell *matCellDef="let element" class="td-1">
            {{element.pps_n}}
        </td>
      </ng-container>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>Action</th>
        <td mat-cell *matCellDef="let element">
          <div class="d-flex  ">
            <div class="action-icon  me-2 " 
              matTooltip="Edit">
              <img src="assets/images/icons/edit-icon.svg"  (click)="onEditItem(element)" class="img-fluid" alt="">
            </div>
            <div class="action-icon  me-2" (click)="onDeleteItem(element.id)" matTooltip="Delete">
              <img src="assets/images/icons/delete-icon.svg">
            </div>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>
  <div class="mat-table__message" *ngIf="dataSource.data.length==0">
    <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
  </div>
  <div class="d-flex justify-content-between align-items-center flex-wrap" *ngIf="dataSource.data.length!=0">
    <div class="me-3 text-grey d-flex align-items-center">
      Showing Items per page
      <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event)" [(ngModel)]="config.itemsPerPage">
        <option [value]="item" *ngFor="let item of pageSizeOptions">{{ item }}</option>
      </select>
    </div>
    <div>
      <ngb-pagination [collectionSize]="count" [(page)]="config.currentPage" [pageSize]="config.itemsPerPage"
        [maxSize]="maxPaginationSize" (pageChange)="onPageChange($event)"></ngb-pagination>
    </div>
  </div>